const membershipContent = {
  sectionTitle: "Mitgliedschaft",
  image: {
    src: "/Mitgliedschaft/1.webp",
    alt: "Mitglied werden",
  },
  title: "Du willst Mitglied im Verein werden?",
  paragraphs: [
    "Unser Verein würde gern noch einige tatkräftige Mitglieder aufnehmen, denen sowohl das Angeln als auch der Verein am Herzen liegen. Aus unserer Tradition, mit unserem Vereinsgrundstück und den vielfältigen Aktivitäten im sportlichen und gemeinschaftlichen Leben ergeben sich viele Aufgaben, die aktives Engagement von jedem Mitglied erfordern. Gleichzeitig möchten wir unseren langjährig aktiven Mitgliedern etwas mehr Ruhe und Zeit zum Angeln gönnen.",
    "Wenn du der Meinung bist, dass du etwas zu unserem Verein beitragen kannst, freuen wir uns über deine Bewerbung per E-Mail. Bitte gib in deiner Nachricht folgende Informationen an:",
  ],
  applicationFields: [
    "Vor- und Nachname",
    "Alter",
    "Wohnort",
    "Kurze Begründung, warum du Mitglied werden möchtest",
    "Erfahrungen im Angeln oder Vereinsaktivitäten (falls vorhanden)",
    "Kontaktdaten für Rückfragen (Telefon/E-Mail)"
  ],
  fees: [
    "Aufnahmegebühr: 50€",
    "Monatlicher Beitrag: 5€ (Kinder zahlen die Hälfte)",
    "Mitgliedsgebühr DAV Berlin: 23,60€",
    "Mitgliedsgebühr DAV Brandenburg: 70,10€"
  ],
  contactEmail: "info@angelfreunde1866.de"
};

export default membershipContent;
